module.exports = __webpack_public_path__ + "static/img/ai-ronghe.1fd536ed.jpg";